// Global CSS imports
import './assets/main.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'primeflex/primeflex.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import '/node_modules/flag-icons/css/flag-icons.min.css'

// import 'primeicons/primeicons.css'

// Third-party libraries and PrimeVue theme
import { axiosPlugin } from './plugins/axios'
import i18nPlugin, { registerModuleTranslations } from './plugins/i18n'
import { getAllModuleTranslations } from '../modules'

import { createApp, provide } from 'vue'

// PrimeVue
import PrimeVue from 'primevue/config'
import AIRiNPreset from './theme/preset'

import 'bootstrap'
import { createPinia } from 'pinia'
import { VueDraggableNext } from 'vue-draggable-next'

// PrimeVue components and services
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import ConfirmationService from 'primevue/confirmationservice'

// Global Custom Functions
import gF from './composables/globalFunctions'

// Main app component and routers
import App from './App.vue'
import router from './router'

// limited Editor for quill
import LimitedEditor from './components/LimitedEditor.vue'

// Module translations are merged AFTER i18n is fully initialized to avoid
// the circular dependency between the i18n plugin and the module registry.
registerModuleTranslations(getAllModuleTranslations())

// Initialize Vue app
const app = createApp(App)
app.use(i18nPlugin)

app.use(axiosPlugin)

app.provide('gF', gF())

// Use plugins and services
app.use(createPinia())
app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: AIRiNPreset,
    options: {
      prefix: 'p',
      darkModeSelector: '.my-app-dark',
      cssLayer: false
    }
  }
})
app.use(ToastService)
app.use(ConfirmationService)
app.component('VueDraggableNext', VueDraggableNext)
app.directive('tooltip', Tooltip)

//app.config.globalProperties.$axios = axiosInstance

app.config.warnHandler = (msg, instance, trace) => {
  // `trace` is the component hierarchy trace
  console.warn(`[Vue warn]: ${msg}\nTrace: ${trace}`)
}

app.config.errorHandler = (err, instance, info) => {
  const message = err instanceof Error ? err.message : String(err)

  app.config.globalProperties.$toast?.add({
    severity: 'error',
    summary: 'Fehler',
    detail: message,
    life: 5000
  })

  if (import.meta.env.DEV) {
    console.error(err, info)
  }
}

window.addEventListener('unhandledrejection', (event) => {
  app.config.globalProperties.$toast?.add({
    severity: 'error',
    summary: 'Unhandled Error',
    detail: event.reason?.message || 'Unbekannter Fehler',
    life: 5000
  })
})

// custom editor toolbar settings for limited editor
app.provide('quillToolbar', [['bold', 'italic', 'link']])

// Register custom global components
app.component('LimitedEditor', LimitedEditor)

app.use(router)

// Mount the app
app.mount('#app')
